import { Link } from "react-router-dom";
export function PrimaryButton({
  children,
  to,
  icon,
  className = "",
  type = "button",
  onClick,
  disabled,
}) {
  const content = (
    <>
      {children}
      {icon && <i className={`fa-solid ${icon}`} />}
    </>
  );
  if (to)
    return (
      <Link to={to} className={`btn btn-brand ${className}`}>
        {content}
      </Link>
    );
  return (
    <button
      type={type}
      className={`btn btn-brand ${className}`}
      onClick={onClick}
      disabled={disabled}
    >
      {content}
    </button>
  );
}
export function SectionTitle({ eyebrow, title, copy, action, to }) {
  return (
    <div className="section-heading d-flex justify-content-between align-items-end gap-3">
      <div>
        {eyebrow && <span className="eyebrow">{eyebrow}</span>}
        <h2>{title}</h2>
        {copy && <p>{copy}</p>}
      </div>
      {action && (
        <Link to={to} className="text-link d-none d-sm-inline-flex">
          {action} <i className="fa-solid fa-arrow-right" />
        </Link>
      )}
    </div>
  );
}
